<div class="modal-header">
	<h4 class="head head4">{{ modalTitle }}</h4>
	<span class="close" (click)="activeModal.dismiss()">
		<fa-icon [icon]="['fas', 'times']" size="lg"></fa-icon>
	</span>
</div>

<ng-content></ng-content>